import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const translations = {
  ka: {
    backToHome: "მთავარ გვერდზე დაბრუნება",
    pageTitle: "ინდივიდუალური წარმოება",
    description: "მორგებული გადაწყვეტილებები თქვენი თხილის დამუშავების სპეციფიკური საჭიროებებისთვის",
    detailedInfo: "ჩვენ ვთავაზობთ ინდივიდუალურ წარმოებას, რომელიც მორგებულია თქვენი ბიზნესის უნიკალურ საჭიროებებზე. ჩვენი გუნდი მჭიდროდ თანამშრომლობს თქვენთან, რათა შექმნას სრულყოფილი გადაწყვეტა თხილის დამუშავებისთვის.",
    features: "ძირითადი მახასიათებლები",
    feature1: "სრულად მორგებული დიზაინი",
    feature2: "თქვენი საჭიროებების ანალიზი",
    feature3: "ოპტიმიზირებული წარმოების პროცესი",
    feature4: "ფასის კონკურენტული შეთავაზება",
    feature5: "ტექნიკური მხარდაჭერა",
    feature6: "მონტაჟი და ინსტალაცია"
  },
  en: {
    backToHome: "Back to Home",
    pageTitle: "Custom Manufacturing",
    description: "Tailored solutions for your specific hazelnut processing needs",
    detailedInfo: "We offer custom manufacturing that is tailored to your business's unique needs. Our team works closely with you to create the perfect solution for hazelnut processing.",
    features: "Key Features",
    feature1: "Fully customized design",
    feature2: "Analysis of your needs",
    feature3: "Optimized production process",
    feature4: "Competitive price offer",
    feature5: "Technical support",
    feature6: "Installation and setup"
  },
  ru: {
    backToHome: "Вернуться на главную",
    pageTitle: "Индивидуальное производство",
    description: "Индивидуальные решения для ваших конкретных потребностей в переработке фундука",
    detailedInfo: "Мы предлагаем индивидуальное производство, адаптированное к уникальным потребностям вашего бизнеса. Наша команда тесно сотрудничает с вами для создания идеального решения для переработки фундука.",
    features: "Основные характеристики",
    feature1: "Полностью индивидуальный дизайн",
    feature2: "Анализ ваших потребностей",
    feature3: "Оптимизированный производственный процесс",
    feature4: "Конкурентное ценовое предложение",
    feature5: "Техническая поддержка",
    feature6: "Монтаж и установка"
  }
};

export default function ServiceCustomManufacturing({ language = 'ka' }) {
  const navigate = useNavigate();
  const t = translations[language];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-5xl mx-auto px-4 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center space-x-2 text-slate-700 hover:text-orange-500 mb-8 transition"
        >
          <ArrowLeft size={20} />
          <span>{t.backToHome}</span>
        </button>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?w=1200"
            alt={t.pageTitle}
            className="w-full h-96 object-cover"
          />
          
          <div className="p-8">
            <h1 className="text-4xl font-bold text-slate-800 mb-4">{t.pageTitle}</h1>
            <p className="text-xl text-slate-600 mb-8">{t.description}</p>
            
            <p className="text-slate-700 mb-8 leading-relaxed">{t.detailedInfo}</p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">{t.features}</h2>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature1}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature2}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature3}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature4}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature5}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature6}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
